import {
  MDBAlert, MDBBtn, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader,
  MDBModalTitle, MDBSelect, MDBSpinner, MDBTable, MDBTableBody, MDBTableHead
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import {
  addDevicePhone,
  getExisting911Locations,
  getPhoneDevicesList,
  getUserListInAddDevicepage,
  getdevicedatainfo,
  getExistingOnly911Locations,
} from "../../../apiclients/streamsapi_bridge";
import AddNineOneOneLocation from "../locations/Add911Location";
import PopupLoaderNew from "../PopupLoaderNew";
import { customSearchFn } from "../../../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../../../apiclients/UIConstant";

function AddDevices(props) {
  const navigate = useNavigate();
  console.log("[AddDevices] Props", props);
  console.dir(props);

  const [replaceDeviceInfo, setReplaceDeviceInfo] = useState(
    props?.replaceDeviceInfo ? props?.replaceDeviceInfo : {}
  );
  const [isReplace, setIsReplace] = useState(Object.keys(replaceDeviceInfo).length > 0 && !replaceDeviceInfo.hasOwnProperty("reuseDevice") ? true : false) 
  const [isloading, setIsloading] = useState(false);
  const [isError, setError] = useState(false);
  const [addDevice, setaddDevice] = useState(false);
  const AddDeviceToggle = () => setaddDevice(!addDevice);

  const { t, i18n } = useTranslation();
  const [formErrors, setformErrors] = useState({}); //it will display errors in form
  const [useAssignedUserNameisChecked, setIsAssignedUserNameisChecked] = useState(true);
  const [ipPhonedevicesInfo, setipPhonedevicesInfo] = useState([
    { designation: "IP Phone 1", model: "-", macAdress: "-", value: 1 },
    { designation: "IP Phone 2", model: "-", macAdress: "-", value: 2 },
  ]);
  const [selectedDesignation, setSelectedDesignation] = useState(1);
  const [showHideAutoFormFields, setshowHideAutoFormFields] = useState(true); //showHideAutoFormFields => Auto->True ; Manual->False;
  const [addDeviceForm, setaddDeviceForm] = useState({
    friendlyName: replaceDeviceInfo?.phonename || "",
    switchAgentid: replaceDeviceInfo?.agentId || "",
    designationPhone: "",
    provisioningType:replaceDeviceInfo?.provisioning_type === 3 ? 1 : parseInt(replaceDeviceInfo?.provisioning_type) || 1 , //parseInt is used to convert the resulting string into an integer. The second argument 10 specifies the base (decimal) for parsing the string.-Ganesh
    deviceType: 1,
    phoneModel: replaceDeviceInfo?.devicename || "",
    macAddress: replaceDeviceInfo?.macaddress || "", //replaceDeviceInfo is not null and if it has a property macaddress. If it does, it assigns the value of replaceDeviceInfo.macaddress to macAddress. If not, it assigns a space character " " to macAddress. This is a concise way to handle null or undefined values and prevent null exceptions.-Ganesh
    ipPhoneTypeid: replaceDeviceInfo.ipphonetype_id || "",
    brand: replaceDeviceInfo?.brandname || "",
    locationId: replaceDeviceInfo?.profileId || "",
    fnameLname: "",
  });

  const [rerender, setRerender] = useState(true);

  const [replaceDevice, setReplaceDevice] = useState(false);
  const toggleShow7 = () => setReplaceDevice(!replaceDevice);
  const [isReplaceDevice, setIsReplaceDevice] = useState(false);
  // updateForm({ switchAgentid: "jyothi@pandoralabs" });
  // const [, setAgentValue] = useState("jyothi@pandoralabs");
  const [replacedeviceMac, setReplacedeviceMac] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const addLocRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [selectClose, setSelectClose] = useState(false)

  const selectRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [unassignDropdownOpen, setUnassignDropdownOpen] = useState(false);
  const [provisioningTypedropdown, setProvisioningTypeDropdown] = useState(false);
  const [locationdropdown, setLocationDropdown] = useState(false);
  const [newDevicedropdown, setnewDevicedropdown] = useState(false);
  const [modeldropdown, setModeldropdown] = useState(false);


  // const handleScroll = (e) => {
  //   if (selectRef.current && selectRef.current.contains(e.target)) {
  //     return;
  //   }
  //   else {
  //     setDropdownOpen(false);
  //     setProvisioningTypeDropdown(false);
  //     setLocationDropdown(false);
  //     setnewDevicedropdown(false);
  //     setModeldropdown(false);
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll, true);

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll, true);
  //   };
  // }, []);






  function handleClick() {
    addLocRef.current.click();
  }
  function openPhoneModel() {
    setModeldropdown(true);
    const phoneModelsData = phoneModels.filter((model) => model.value !== "");
    setphoneModelsResponse(phoneModelsData);
  }
  function closePhoneModel() {
    console.log("Hellooo", addDeviceForm?.phoneModel)
    setModeldropdown(false);
    if (addDeviceForm?.phoneModel[0] == "" || addDeviceForm?.phoneModel == "") {
      let phoneModelsData = [{ text: "Search...", value: "", id: 0, brandName: "" }, ...phoneModels]; //Adding Default options for select in first position of select box
      setphoneModelsResponse(phoneModelsData);
      console.log("Hellooo")
    }
  }
  function openUsersPopup() {
    setDropdownOpen(true);
    const filteredAgents = agentResponse.filter((agent) => agent.value !== "");
    setagentResponse(filteredAgents);
  }
  function closeUsersPopup() {
    console.log("closeUsersPopup :: " + addDeviceForm.switchAgentid);
    setDropdownOpen(false);
    if (addDeviceForm?.switchAgentid == "") {
      const updatedAgents = [
        { text: "Search...", value: "" },
        ...agentResponse
      ];
      setagentResponse(updatedAgents);
    }
  }
  function openUnassignPopup() {
    setUnassignDropdownOpen(true);
  }
  function closeUnassignPopup() {
    setUnassignDropdownOpen(false);
   
  }
  const handleSelectChangeAgent = async (event) => {
    console.dir(event);
    setDropdownOpen(false)
    //setSelectedDesignation(1);
    if (event && event.value && event.text) {
      console.dir(event.text);
      updateForm({ switchAgentid: event.value });
      await getPhoneDesignationsforAgent(event.value, event.text);
      updateForm({ fnameLname: event.text });
      formErrors.switchAgentidError = ""
      setError()
    }
  };
  const setSelectOption = () => {
    setSelectClose(false)
  }
  const getPhoneDesignationsforAgent = async (agent, agentFNLN) => {
    console.log("Request came to getPhoneDesignationsforAgent :");
    try {
      if (agent == "") {
        return;
      }
      let params = { agentid: agent };
      let deviceApiResponse = await getdevicedatainfo(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        params
      );
      if (!deviceApiResponse.ok) {
        console.log("Network response was not ok");
        console.log(deviceApiResponse);
        setError(true);
        throw new Error("Network response was not ok");
      } else {
        let apiResponsejson = await deviceApiResponse.json();
        let phoneModelsData = apiResponsejson.deviceInfo;
        console.log(
          "provisioned Devices list : " + JSON.stringify(phoneModelsData)
        );
        if (phoneModelsData[0].macAddress !== "-" || phoneModelsData[0].model !== "-" || phoneModelsData[0].macAdress == "Manual") {
          setIsReplaceDevice(true);
        } if (phoneModelsData[1].macAddress !== "-" || phoneModelsData[1].model !== "-" || phoneModelsData[1].macAdress == "Manual") {
          setIsReplaceDevice(true);
        }
        if (isReplace) {
          let replaceModels = phoneModelsData.filter((item) => item.designation === replaceDeviceInfo?.designation)
          setipPhonedevicesInfo(replaceModels);
        } else {
          setipPhonedevicesInfo(phoneModelsData);
        }
        if (replaceDeviceInfo && replaceDeviceInfo.designation) {
          //designation: "IP Phone 1"
          const designation = replaceDeviceInfo.designation.includes("1")
            ? 1
            : 2;
          if (phoneModelsData[0].macAddress == "-" || phoneModelsData[1].macAddress == "-") {
            setIsReplaceDevice(false);
          } else {
            setIsReplaceDevice(true);
          }
          //setSelectedDesignation(designation);
          prefillFriendlyName(designation, agentFNLN);
          updateForm({ designationPhone: designation });
        } else {
          selectDefualtPhoneDesignationsChk(phoneModelsData, agentFNLN);
        }
      }
    } catch (e) {
      console.log("Error in getPhoneDesignationsforAgent" + e);
    }
  };

  const selectDefualtPhoneDesignationsChk = (phoneModelsData, agentFNLN) => {
    console.log("check boxes selcting ");
    console.log(
      "phoneModelsData[0].model: " +
      phoneModelsData[0].model +
      "phoneModelsData[1].model:" +
      phoneModelsData[1].model
    );
    if (
      (phoneModelsData[0].model !== "-" && phoneModelsData[1].model !== "-") ||
      (phoneModelsData[0].model !== "-" && phoneModelsData[1].model !== "-")
    ) {
      setSelectedDesignation(1);
      prefillFriendlyName(1, agentFNLN);
      updateForm({ designationPhone: 1 });
    } else if (phoneModelsData[0].model == "-") {
      setSelectedDesignation(1);
      prefillFriendlyName(1, agentFNLN);
      setIsReplaceDevice(false);
      updateForm({ designationPhone: 1 });
    } else {
      setSelectedDesignation(2);
      prefillFriendlyName(2, agentFNLN);
      updateForm({ designationPhone: 2 });
      setIsReplaceDevice(false);
    }
  };

  const options = [];
  const [agentResponse, setagentResponse] = useState(options);
  const [phoneModels, setphoneModelsResponse] = useState(options);
  const [locationsInfo, setLocationsInfo] = useState([]);
  const [unassigndeviceList, setUnassigndeviceList] = useState([]);
  const [locationName, setLocationName] = useState("")
  const addLocationRef = useRef(null);

  function prefillFriendlyName(desigation, text) {
    try {

     
      if (!desigation || desigation == 1) {
        updateForm({ friendlyName: text + " IP1 " });
      } else if (desigation == 2) {
        updateForm({ friendlyName: text + "  IP2 " });
      }
    } catch (e) {
    }
  }
  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);
  // console.log("Location 911",locationName)

  useEffect(() => {
    getAgentsData();
    fetchData();
    getLocationsList();
  }, []);

  const getAgentsData = async () => {
    console.log("[agents]request came to getUserListInAddDevicepage");
    try {
      setIsloading(true)
      let userListRespons = await getUserListInAddDevicepage(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      if (!userListRespons.ok) {
        console.log("got an issue whie");
        throw new Error("Network response was not ok");
      }
      let responseData = await userListRespons.json();
      console.log("getUserListInAddDevicepage  " + responseData);
      let switchuserData = responseData.agentNames_Models_Info.agents;
      switchuserData.unshift({ text: "Search...", value: "" }); //Adding Default options for select in first position of select box
      setagentResponse(switchuserData);
      let phoneModelsData = responseData.agentNames_Models_Info.phonemodel;
      phoneModelsData.unshift({
        text: "Search...",
        value: "",
        id: 0,
        brandName: "",
      }); //Adding Default options for select in first position of select box

      console.log("phoneModelsData   :::::::::  " + JSON.stringify(phoneModelsData));
      setphoneModelsResponse(phoneModelsData);
      setTimeout(() => {
        setIsloading(false)
      }, 1000)
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchData = async () => {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      console.log("Makinge request for getPhoneDevicesList ");
      let saverepData = await getPhoneDevicesList(siteid);
      if (!saverepData.ok) {
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        let saverepeMsg = await saverepData.json();
        let unAssignedListArray = saverepeMsg.phoneDetails.unassigned_list;
        // let unAssignedphoneDetails = [];
        console.log("unAssignedListArray  " + JSON.stringify(unAssignedListArray));
        const finalList = unAssignedListArray.map((item) => {
          return {
            value: item.macAddress,
            text: `${item.macAddress} (${item.modelName})`,
            modelName: item.modelName,
            profile_id: item.profile_id
          };
        });
        finalList.unshift({ text: "Select Mac Address", value: "" });
        console.log("finalList :: " + JSON.stringify(finalList));
        console.dir(finalList);
        console.log("911finalList  nineoo_loc_id :: " + JSON.stringify(finalList));
        setUnassigndeviceList(finalList);
      }
    } catch (e) {
      console.log("[PSLanding.js] Error while fetching data from API : " + e);
    }
  };

  async function getLocationsList() {
    console.log("[agents]request came getExisting911Locations");
    try {
      let locationsList = await getExistingOnly911Locations(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      if (!locationsList.ok) {
        console.log("got an issue whie");
        throw new Error("Network response was not ok");
      }
      let responseData = await locationsList.json();
      console.log(
        "getExisting911Locations responseData  " + JSON.stringify(responseData)
      );
      if (responseData.status == "success") {
        const finalList = responseData.nineoolocations.map((item) => {
          return {
            value: item.nineoo_loc_id,
            text: item.nineoo_loc_name,
          };
        });
        finalList.unshift({ text: "Select 911 Location", value: "" });
        console.log("911finalList :: " + finalList);
        setLocationsInfo(finalList);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  // useEffect(() => {
  //   if (rerender) {
  //     getLocationsList();
  //     setRerender(false);
  //   }
  // }, [rerender]);

  const [isValidMacAddress, setIsValidMacAddress] = useState(true);
  const handleMacAddressChange = (event) => {
    if (event && event.target) {
      const value = event.target.value.replace(/\s+/g, "");
      console.log("MacAdress eventValue : " + value);
      //setMacAddress(event.target.value);
      updateForm({ macAddress: value });
      const strippedMacAddress = value
        .toUpperCase()
        .replace(/[:-]/g, "");
      setIsValidMacAddress(validateMacAddress(strippedMacAddress));
      formErrors.macAddressError = ""
      console.log("Mac Adress:" + value);
    }
  };
  const validateMacAddress = (mac) => {

    mac = String(mac)
    const stripped = mac.replace(/[^A-Fa-f0-9]/g, '');
    return /^[A-Fa-f0-9]{12}$/.test(stripped) && /[0-9]/.test(stripped);
  };

  const handleAutoManual = (e) => {
    setProvisioningTypeDropdown(false);
    if (e && e.value) {
      updateForm({ provisioningType: e.value });
      console.log("value ::::: aps :" + e.value);
      setshowHideAutoFormFields(e.value == 1 ? true : false);
    }
  };
  const handleDeviceType = (e) => {
    updateForm({ deviceType: e.value });
    if (e && e.value == 1) {
      updateForm({ macAddress: "", phoneModel: [0] });
    }
  };
  const handlePhoneModel = (e) => {
    setModeldropdown(false);
    if (e && e.value && e.id && e.brandName) {
      updateForm({ phoneModel: e.value });
      updateForm({ ipPhoneTypeid: e.id });
      updateForm({ brand: e.brandName });
      formErrors.phoneModelError = ""
    }
  };
  const handleLocation = (e) => {
    setLocationDropdown(false);
    updateForm({ locationId: e?.value });
    formErrors.locationError = ""
  };
  const onPhoneDisignationSelect = (e) => {
    console.log("ipPhonedevicesInfo :::::::: " + ipPhonedevicesInfo);
    console.log("e.target.value :::: " + e.target.value + "data is :::: " + ipPhonedevicesInfo[e.target.value]);
    console.dir("Object ::::::::::: " + e);
    console.log("checked value :" + e.target.checked + " event value :" + e.target.value);
    if (e.target?.value && ipPhonedevicesInfo) {
      if (e.target.value == 2) {
        updateForm({ friendlyName: addDeviceForm && addDeviceForm.friendlyName ? addDeviceForm.friendlyName.replace("IP1", "IP2") : "" });
      } else if (e?.target?.value == 1) {
        updateForm({ friendlyName: addDeviceForm && addDeviceForm.friendlyName ? addDeviceForm.friendlyName.replace("IP2", "IP1") : "" });
      }
      let value = parseInt(e.target.value);
      if (value == 2) {
        value = 1;
      } else {
        value = 0;
      }
      let checkedDeviceInfo = ipPhonedevicesInfo[value];
      if (checkedDeviceInfo?.model !== "-" || checkedDeviceInfo?.macAdress == undefined || checkedDeviceInfo.macAdress == "Manual" || checkedDeviceInfo?.model !== "-") {
        setIsReplaceDevice(true);
      } else {
        setIsReplaceDevice(false);
      }
    }
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedDesignation(e.target.value);
      updateForm({ designationPhone: parseInt(e.target.value) });
    }
  };
  const handleCheckboxChange = () => {
    console.log("assigned user name :" + useAssignedUserNameisChecked);
    setIsAssignedUserNameisChecked(!useAssignedUserNameisChecked);
  };

  function updateForm(val) {
    console.log("value :" + val);
    console.dir(val);
    setaddDeviceForm((prevFormData) => ({
      ...prevFormData,
      ...val,
    }));
    setTimeout(function () {
      console.log(addDeviceForm);
    }, 5000);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("addDeviceForm : " + addDeviceForm.friendlyName);

    console.log("Request came to validatAddDeviceForm");

    const validationErrors = {}; // Perform validation

    if (
      !useAssignedUserNameisChecked &&
      (addDeviceForm.friendlyName === "" ||
        addDeviceForm.friendlyName.trim() === "")
    ) {
      validationErrors.friendlyError = "Please enter a name for the Phone.";
    }

    if (addDeviceForm.switchAgentid === "") {
      validationErrors.switchAgentidError = "Please select user";
    }

    if (addDeviceForm.designationPhone.length === 0) {
      validationErrors.designationPhoneError =
        "Please check any phone designation";
    }

    if (
      addDeviceForm.provisioningType === "" ||
      addDeviceForm.provisioningType == "0"
    ) {
      validationErrors.provisioningTypeError =
        "Please select a provisioning type.";
    }

    if (
      showHideAutoFormFields &&
      (addDeviceForm.deviceType === "" || addDeviceForm.deviceType == "0")
    ) {
      //showHideAutoFormFields => Auto->True ; Manual->False
      validationErrors.deviceTypeError = "Please select a device type.";
    }
    if (showHideAutoFormFields && addDeviceForm.phoneModel[0] == 0 || addDeviceForm.phoneModel === "") {
      //showHideAutoFormFields => Auto->True ; Manual->False
      validationErrors.phoneModelError = "Please select a phone model.";
    }

    if (showHideAutoFormFields && (!isValidMacAddress || addDeviceForm.macAddress === "")) {
      //showHideAutoFormFields => Auto->True ; Manual->False
      validationErrors.macAddressError =
        "Please enter a valid phone Mac Address.";
    }

    if (addDeviceForm.locationId === "" || !addDeviceForm.locationId) {
      validationErrors.locationError = "Please select Location ";
    }
    if (addDeviceForm.deviceType == "2" && unassigndeviceList.length > 1 && !addDeviceForm.macAddress) {
      validationErrors.unassignDeviceError = "Please select Unassign Device.";
    }
    if (Object.keys(validationErrors).length > 0) {
      setformErrors(validationErrors); //it will display form errors
      return;
    } else {
      setformErrors(validationErrors); //it will remove already shown errors in UI
    }

    if (isReplacingExistingDevice()) {
      //if user doing replace Device, then will show replace device popup
      console.log("Replace device popup is displayed ");
      setReplaceDevice(!replaceDevice);
    } else {
      console.log("Sending request to node server ");
      provisioningRequesttoServer(); // will directly send Provisioning request to Nodeserver Api
    }
  };

  const provisioningRequesttoServer = async () => {
    // If validation passes, submit the form to the API
    const apiData = prepareFormData();
    setIsloading(true);
    const serverRes = await addDevicePhone(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      apiData
    );
    let saverepMsg = await serverRes.json();
    if (serverRes.status === 500) {
      setTimeout(() => {
        setIsloading(false);
      }, 3000);
      setError(true);
    } else if (serverRes.status === 422) {
      setIsloading(false);
      var param_name = saverepMsg.message.customData.errors[0].param_name;
      var message = saverepMsg.message.customData.errors[0].message;
      if (param_name === "device_macadress" || param_name === "device_model") {
        setIsValidMacAddress(false);
        const validationError = {
          macAddressError: message,
        };
        setformErrors(validationError);
      }
    } else {
      setIsloading(false);
      localStorage.setItem("s_message", "Device added successfully. Please reboot the device.");
      console.log(saverepMsg.sucessData);
      props.onClose();
      console.log("saverepMsg.responseData  " + JSON.stringify(saverepMsg.responseData));
      if (apiData.provisioning * 1 == 1) {
        navigate("/ipphoneadd", {
          state: { macAdress: saverepMsg.responseData.macAdress, device: JSON.stringify({})},
        });
      }else if(apiData.provisioning * 1 == 3){
        navigate("/YealinkSettings", {
          state: { macAdress: saverepMsg.responseData.macAdress, device: JSON.stringify({})},
        });
      } 
      else {
        navigate("/manualdevicesettings", {
          state: {
            deviceUUID: saverepMsg.responseData.deviceUUID, device: JSON.stringify({})
          },
        });
      }
      // navigate("/pslanding", {
      //   state: { tab: "tab2" },
      // });
      console.log("window.location  :::: " + window.location);
      window.location.reload();
    }
  };

  const isReplacingExistingDevice = () => {
    console.log(
      "[AddDevice.js][isReplacingExistingDevice] Checking is Replace device Request ? : "
    );
    try {
      // selectedDesignation => designation selected by user in addDevice page
      let selectedPhone = ipPhonedevicesInfo[selectedDesignation == 1 ? 0 : 1]; //selected Phone contains jo object{} with Existing MacAdress and Model name
      if (selectedPhone.macAdress !== "-") {
        //setReplacedeviceMac(selectedPhone.macAdress);
        console.log(
          "[AddDevice.js][isReplacingExistingDevice] Yes it is Replace Add device Request " +
          selectedPhone.macAdress
        );
        return selectedPhone; // conatians macAdress text || Manual text
      } else {
        return null;
      }
    } catch (e) {
      console.error("[AddDevice.js][isReplacingExistingDevice]  Error " + e);
    }
  };

  const prepareFormData = () => {
    console.log("Prepareing form data2 " + JSON.stringify(addDeviceForm));
    const formData = {};
    if (addDeviceForm.provisioningType == 1) {
      // Add Auto form data
      formData.reqid = 19;
      formData.friendly_name = useAssignedUserNameisChecked
        ? getFriendlyName()
        : addDeviceForm.friendlyName;
      formData.agentid = addDeviceForm.switchAgentid;
      formData.designation = addDeviceForm.designationPhone;
      formData.provisioning = addDeviceForm.provisioningType === 1 && UIConstant.DECT_MODELS.includes(addDeviceForm.phoneModel) ? 3 : addDeviceForm.provisioningType;
      formData.device_type = addDeviceForm.deviceType;
      formData.device_model = addDeviceForm.phoneModel;
      formData.device_macadress = addDeviceForm.macAddress.replace(/[:-]/g, "");
      formData.locationId = addDeviceForm.locationId;
      formData.device_brand = addDeviceForm.brand;
      formData.ipphonetypeid = addDeviceForm.ipPhoneTypeid ? addDeviceForm.ipPhoneTypeid : replaceDeviceInfo?.ipphonetype_id;
      formData.siteid = JSON.parse(
        sessionStorage.getItem("admin_session")
      ).siteid;
    } else if (addDeviceForm.provisioningType == 2) {
      // Add Manual form data
      formData.reqid = 29;
      formData.friendly_name = useAssignedUserNameisChecked
        ? getFriendlyName()
        : addDeviceForm.friendlyName;
      formData.agentid = addDeviceForm.switchAgentid;
      formData.designation = addDeviceForm.designationPhone;
      formData.provisioning = addDeviceForm.provisioningType;
      formData.locationId = addDeviceForm.locationId;
      formData.siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
    }
    const exist_MacAdress = isReplacingExistingDevice();
    if (exist_MacAdress != null) {
      formData.exist_macadress = exist_MacAdress;
    }
    console.log("Add  Device request Data:::::::::", JSON.stringify(formData));
    return formData;
  };

  const getFriendlyName = () => {
    console.log("get friendly name :");
    let framingName = "";
    if (addDeviceForm.designationPhone == 1) {
      framingName = addDeviceForm.fnameLname + " IP1";
    } else if (addDeviceForm.designationPhone == 2) {
      framingName = addDeviceForm.fnameLname + " IP2";
    } else {
      framingName = addDeviceForm.switchAgentid;
    }
    console.log("framingName :" + framingName);
    return framingName;
  };

  const fnameRef = useRef();
  useEffect(() => {
    setTimeout(() => {
      fnameRef.current.focus();
    }, 500);
  }, []);
  // if (props.status) {
  //   setAdd911Location(!Add911Location);
  // }
  const placementExample = useRef(null);
  const [Add911Location, setAdd911Location] = useState(false);
  const [newLocation, setNewLocation] = useState({})
  const toggleShow25 = async (data) => {
    try {
      let locationsList = await getExistingOnly911Locations(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid
      );
      if (!locationsList.ok) {
        console.log("got an issue whie");
        throw new Error("Network response was not ok");
      }
      let responseData = await locationsList.json();
      console.log(
        "getExisting911Locations responseData  " + JSON.stringify(responseData)
      );
      if (responseData.status == "success") {
        const finalList = responseData.nineoolocations.map((item) => {
          return {
            value: item.nineoo_loc_id,
            text: item.nineoo_loc_name,
          };
        });
        finalList.unshift({ text: "Select 911 Location", value: "" });
        console.log("911finalList :: " + JSON.stringify(finalList));
        setLocationsInfo(finalList);
        let newLocationData = finalList.find((item) => item.text === data);

        console.log("newLocation", newLocationData)
        setNewLocation(newLocationData)
      }
    } catch (error) {
      console.error("Error:", error);
    }
    setAdd911Location(!Add911Location);
  }
  useEffect(() => {
    setaddDeviceForm({ ...addDeviceForm, locationId: newLocation?.value, });
  }, [newLocation])


  const handleClickOutside = (event) => {
    const selectContainers = document.querySelectorAll(".select-search-input, .select-option, .select-dropdown"); // allow inside clicks
    const isClickInsideDropdown = Array.from(selectContainers).some((el) => el.contains(event.target));

    if (selectRef.current && !selectRef.current.contains(event.target) && !isClickInsideDropdown) {
      setDropdownOpen(false);
      setProvisioningTypeDropdown(false);
      setLocationDropdown(false);
      setnewDevicedropdown(false);
      setModeldropdown(false);
      setUnassignDropdownOpen(false)
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);




  return (
    <>
      <div>
        {isloading && (
          <div>
            <div className="loadingclass-popup"></div>
            <div className="popup-bg-loader loader_align">
              <MDBBtn disabled>
                <MDBSpinner
                  size="sm"
                  role="status"
                  tag="span"
                  className="me-2"
                />
                Loading...
              </MDBBtn>
            </div>
          </div>
        )}
        {successMessage && (
          <MDBAlert
            open
            color="success"
            position="bottom-right"
            delay={1000}
            className="alert-center"
          >
            <i className="fas fa-check-circle me-3"></i>
            <span className="alert-msg">{successMessage}</span>
          </MDBAlert>
        )}

        {!isloading && isError && (
          <MDBAlert
            open
            className="alert-center"
            color="danger"
            autohide
            position="bottom-right"
            delay={100000}
          >
            {t("Provisioning_Error_Aleart")}
          </MDBAlert>
        )}

        <div className="tel-numbers">
          <strong>{t("Selectuser")}</strong>
        </div>
        <div className="form pt-1">
          <div ref={selectRef}>
            <MDBSelect
              className="w-100"
              placeholder="Search..."
              onChange={handleSelectChangeAgent}
              data={agentResponse}
              visibleOptions="3"
              value={addDeviceForm.switchAgentid}
              search
              // searchFn={customSearchFn}
              open={dropdownOpen}
              onOpen={() => openUsersPopup()}
              onClosed={() => closeUsersPopup()}
              disabled={isReplace}
            />
          </div>


          {formErrors.switchAgentidError && (
            <span style={{ color: "red" }}>
              {formErrors.switchAgentidError}
            </span>
          )}
        </div>

        {/* <MDBDatatable
                pagination={false}
                data={addDeviceTable}
                onSelectRow={onPhoneDisignationSelect}
                className="mt-0"
            /> */}
        <MDBTable hover>
          <MDBTableHead>
            <tr>
              <th scope="col"></th>
              <th scope="col" className="text-center">
                Designation
              </th>
              <th scope="col" className="text-center">
                Model
              </th>
              <th scope="col" className="text-center">
                MAC Address
              </th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {
              ipPhonedevicesInfo.length > 0 && ipPhonedevicesInfo.map((device) => {
                return <tr key={device}>
                  <th scope="row" className="text-center">
                    <input
                      type="checkbox"
                      id="ip_phone1_id"
                      value={device.value}
                      checked={isReplace ? true : selectedDesignation == device.value}
                      onChange={onPhoneDisignationSelect}
                      disabled={isReplace}
                    />
                  </th>
                  <td className="text-center">
                    {device.designation}
                  </td>
                  <td className="text-center">{device.model}</td>
                  <td className="text-center">{device.macAdress}</td>
                </tr>
              })
            }
            {/* <tr>
              <th scope="row" className="text-center">
                <input
                  type="checkbox"
                  id="ip_phone1_id"
                  value={ipPhonedevicesInfo[0].value}
                  checked={selectedDesignation == ipPhonedevicesInfo[0].value}
                  onChange={onPhoneDisignationSelect}
                />
              </th>
              <td className="text-center">
                {ipPhonedevicesInfo[0].designation}
              </td>
              <td className="text-center">{ipPhonedevicesInfo[0].model}</td>
              <td className="text-center">{ipPhonedevicesInfo[0].macAdress}</td>
            </tr>
            <tr>
              <th scope="row" className="text-center">
                <input
                  type="checkbox"
                  id="ip_phone2_id"
                  value={ipPhonedevicesInfo[1].value}
                  checked={selectedDesignation == ipPhonedevicesInfo[1].value}
                  onChange={onPhoneDisignationSelect}
                />
              </th>
              <td className="text-center">
                {ipPhonedevicesInfo[1].designation}
              </td>
              <td className="text-center">{ipPhonedevicesInfo[1].model}</td>
              <td className="text-center">{ipPhonedevicesInfo[1].macAdress}</td>
            </tr> */}
          </MDBTableBody>
        </MDBTable>
        {/* {formErrors.designationPhoneError && (
          <span style={{ color: "red" }}>
            {formErrors.designationPhoneError}
          </span>
        )} */}
        <div className="tel-numbers">
          <strong>{t("friendlyName")}</strong>
        </div>
        <div className="form pt-1">
          <input
            type="text"
            className="form-control"
            ref={fnameRef}
            placeholder="Please enter friendly phone name"
            value={addDeviceForm.friendlyName}
            disabled={useAssignedUserNameisChecked}
            maxLength={50}
            onKeyDown={(event) => {
              if (!/[a-zA-Z0-9 _@:;]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            onChange={(e) => {
              updateForm({ friendlyName: e.target.value })
            }}
          />
          {formErrors.friendlyError && (
            <span style={{ color: "red" }}>{formErrors.friendlyError}</span>
          )}
        </div>
        <div className="routing-check">
          <input
            type="checkbox"
            className="routing-checks m-1"
            value={useAssignedUserNameisChecked}
            checked={useAssignedUserNameisChecked}
            onChange={handleCheckboxChange}
          />
          {t("UseassignedUserName")}
        </div>
        <div className="tel-numbers pt-3">
          <strong>{t("selectProvisioningType")}</strong>
        </div>
        <div className="text-secondary mb-2">
          {t("selectProvisioningTypetxt")}
        </div>
        <div ref={selectRef}>
          <MDBSelect
            onChange={handleAutoManual}
            classID="w-25"
            data={[
              { text: "Choose your option", value: 0 },
              { text: "Auto", value: 1 },
              { text: "Manual", value: 2 },
            ]}
            value={addDeviceForm.provisioningType}
            open={provisioningTypedropdown}
            onOpen={() => setProvisioningTypeDropdown(true)}
            onClose={() => setProvisioningTypeDropdown(false)}
            disabled={isReplace || replaceDeviceInfo?.reuseDevice === "reuseDevice" }
          />
        </div>
        {formErrors.provisioningTypeError && (
          <span style={{ color: "red" }}>
            {formErrors.provisioningTypeError}
          </span>
        )}
        {showHideAutoFormFields && (
          <div>
            <div className="tel-numbers pt-2 mb-2">
              {
                replaceDeviceInfo?.reuseDevice === "reuseDevice" ? <strong>{t("reuseDevicetxt")}</strong> :   <strong>{t("newDevicetxt")}</strong>
              }  
            </div>
            <div ref={selectRef}>
              <MDBSelect
                onChange={(e) => {
                  setnewDevicedropdown(false);
                  handleDeviceType(e);
                }}
                classID="w-25"
                data={[
                  { text: "Choose your option", value: 0 },
                  { text: "New", value: 1 },
                  { text: "Unassigned", value: 2 },
                ]}
                value={replaceDeviceInfo?.reuseDevice === "reuseDevice" ? 2 : addDeviceForm.deviceType}
                open={newDevicedropdown}
                onOpen={() => setnewDevicedropdown(true)}
                onClose={() => setnewDevicedropdown(false)}
                disabled={replaceDeviceInfo?.reuseDevice === "reuseDevice"}
              />
            </div>

            {formErrors.deviceTypeError && (
              <span style={{ color: "red" }}>{formErrors.deviceTypeError}</span>
            )}
          </div>

        )}

        {/* Show model and MAC address only when "New" is selected */}
        {addDeviceForm.provisioningType == 1 && addDeviceForm.deviceType == 1 && (
          <>
            <div>
              <div className="tel-numbers mt-2">
                <strong>{t("model")}</strong>
              </div>
              <div className="form mt-1 mb-2 " ref={selectRef}>
                <MDBSelect
                  open={modeldropdown}
                  onOpen={() => openPhoneModel()}
                  onClosed={() => closePhoneModel()}
                  onChange={handlePhoneModel}
                  data={phoneModels}
                  placeholder="Choose Phone Model"
                  preventFirstSelected
                  value={!Array.isArray(addDeviceForm?.phoneModel) ? addDeviceForm?.phoneModel : replaceDeviceInfo?.devicename}
                  search
                  // searchFn={customSearchFn}
                />
                {formErrors.phoneModelError && (
                  <span style={{ color: "red" }}>{formErrors.phoneModelError}</span>
                )}
              </div>
            </div>

              <div>
                <div className="tel-numbers">
                  <strong>{t("MACaddress")}</strong>
                </div>
                <div className="form mt-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Please enter phone MacAddress"
                    value={addDeviceForm.macAddress}
                    onChange={handleMacAddressChange}
                  />
                  {formErrors.macAddressError && (
                    <span style={{ color: "red" }}>{formErrors.macAddressError}</span>
                  )}
                </div>
              </div>
            
          </>
        )}

        {addDeviceForm.deviceType == "2" && (
          <div >
            <div className="tel-numbers pt-2 mb-2" ref={selectRef}>
              <strong>{t("UnassignDevice")}</strong>
            </div>
            <MDBSelect
              classID="w-25"
              data={unassigndeviceList}
              value={addDeviceForm.macAddress}
              onChange={(e) => {

                console.log("addDeviceForm.phoneModel :::::::" + addDeviceForm.macAddress);
                console.dir(e);
                if (e && e.text && e.value) {
                  const unassignModel = phoneModels?.find(item => item.text == e.modelName);
                  console.log("unassignModel :::: " + JSON.stringify(unassignModel));
                  updateForm({ macAddress: e.value, phoneModel: e.modelName, locationId: e.profile_id, ipPhoneTypeid: unassignModel?.id, brand: unassignModel?.brandName });
                  formErrors.unassignDeviceError = ""
                  setUnassignDropdownOpen(false);
                }
              }}
              open={unassignDropdownOpen}
              onOpen={() => openUnassignPopup()}
              onClosed={() => closeUnassignPopup()}

            />
            {formErrors.unassignDeviceError && (
              <span style={{ color: "red" }}>{formErrors.unassignDeviceError}</span>
            )}
          </div>
        )}


        <div>
          <div className="tel-numbers mt-2">
            <strong>{t("select911loc")}</strong>
          </div>
          <div className="form mt-1 mb-2">
            <div className="text-secondary"> {t("select911loctxt")}</div>

            <div className="d-flex align-items-center justify-content-between mt-3">
              <div className="w-60" ref={selectRef}>
                <MDBSelect
                  data={locationsInfo}
                  search
                  // searchFn={customSearchFn}
                  open={locationdropdown}
                  placeholder="Select 911 Location"
                  onChange={handleLocation}
                  onOpen={() => setLocationDropdown(true)}
                  onClose={() => setLocationDropdown(false)}
                  value={addDeviceForm?.locationId ? addDeviceForm?.locationId : replaceDeviceInfo?.profileId}
                // onChange={(e) => handleLocation(e.target.value)}
                />
                {formErrors.locationError && (
                  <span style={{ color: "red" }}>
                    {formErrors.locationError}
                  </span>
                )}
              </div>
              <div>
                <MDBBtn fas icon="plus" onClick={toggleShow25}>
                  <MDBIcon fas icon="plus" size="sm" /> {t("add911onlyloc")}</MDBBtn>
              </div>
            </div>
          </div>
        </div>
        {/*  <div className="search-btn">
                <MDBSelect
                    className="w-100"
                    data={[
                        { text: "One" },
                        { text: "Two" },
                        { text: "Three" },
                        { text: "Four" },
                        { text: "Five" },
                        { text: "Six" },
                        { text: "Seven" },
                        { text: "Eight" },
                    ]}
                    clearBtn
                />
                <div className="form-add">
                    <button
                        type="button"
                        className="btn green-button-add  rip ple-surface"
                        data-mdb-toggle="modal"
                        data-mdb-target="#exampleModal"
                    >
                        <MDBIcon fas icon="plus" size="sm" /> {t("add_Numbers")}
                    </button>
                </div>
            </div> */}
        <MDBModalFooter>
          <MDBBtn
            color="secondary"
            className="cancle-btn"
            onClick={(e) => props.onClose(e)}
          >
            {t("close")}
          </MDBBtn>
          {isReplaceDevice ? (
            <MDBBtn onClick={handleSubmit}>{t("Replace")}</MDBBtn>
          ) : (
            <MDBBtn onClick={handleSubmit}>{t("Add")}</MDBBtn>
          )}
        </MDBModalFooter>
      </div>
      <MDBModal open={replaceDevice} setopen={setReplaceDevice} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{t("replaceDevice")}</MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={toggleShow7}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              {t("replace")} <b>{addDeviceForm.fnameLname}</b>{" "}
              {ipPhonedevicesInfo[selectedDesignation == 1 ? 0 : 1].designation}
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color="secondary" onClick={toggleShow7}>
                Cancel
              </MDBBtn>
              <MDBBtn
                onClick={() => {
                  setReplaceDevice(!replaceDevice);
                  provisioningRequesttoServer();
                }}
              >
                Replace
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      {Add911Location && (
        <PopupLoaderNew
          title={t("Add911Loc")}

          content={
            <AddNineOneOneLocation

              setAcdActive={null}
              setReRender={false}
              setSuccessMessage={setSuccessMessage}
              setlocationName={setLocationName}
              removeFlag={true}
              onClose={toggleShow25}
              ref={addLocRef}
              setIsloading={setisLoading}
              isRedirect={false}
              // setName={setLocationName}
              setSelect={setSelectOption}
            />
          }
          // onShow={setAdd911Location}
          onClose={toggleShow25}
          onSave={handleClick}
          isloading={isLoading}
          flag={1}


        />
      )}
      {/* {successMessage && ( */}

      {/* )} */}
    </>
  );
}

export default AddDevices;
